import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CARD_TITLE_CLASSES } from "../constants";

interface CollapsibleCardProps {
  title: string;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  children: React.ReactNode | ((isExpanded: boolean) => React.ReactNode);
  defaultOpen?: boolean;
}

export function CollapsibleCard({
  title,
  icon,
  badge,
  children,
  defaultOpen = true,
}: CollapsibleCardProps) {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <Card className="shadow-none border-secondary-100">
      <button
        type="button"
        className="flex items-center justify-between cursor-pointer select-none w-full text-left"
        onClick={() => setOpen((o) => !o)}
      >
        <CardHeader className="w-full relative">
          <div className="flex items-center gap-2 pr-8">
            {icon}
            <CardTitle className={CARD_TITLE_CLASSES}>{title}</CardTitle>
            {badge}
          </div>
          <div className="absolute top-2 right-2">
            {open ? (
              <ChevronDown className="w-4 h-4 text-secondary-400" />
            ) : (
              <ChevronRight className="w-4 h-4 text-secondary-400" />
            )}
          </div>
        </CardHeader>
      </button>
      {typeof children === "function" ? (
        <CardContent className="pt-2">{children(open)}</CardContent>
      ) : (
        open && <CardContent className="pt-2">{children}</CardContent>
      )}
    </Card>
  );
}
